import { useTranslations } from 'next-intl'
import toasters from '../../../locales/fr/toasters.json'
import { isErrorWithCode } from '@/shared/utils/queryUtils'
import type { ToastData } from '@/shared/v2/shared/components/Toaster/ToasterProvider'
// eslint-disable-next-line data-layer/import-direction -- legacy: makalu still fires toasts from hooks (ERR-4), and this is the one bridge to the toaster
import { useToast } from '@/shared/v2/shared/components/Toaster/ToasterProvider'

const hasToasterTranslation = (code: string): boolean => {
    return Object.keys(toasters['toasters']).includes(code)
}

export const useSetToast = () => {
    const { showToast } = useToast()
    const toasterTranslations = useTranslations('toasters')

    return (props: ToastData, error?: unknown) => {
        if (isErrorWithCode(error) && hasToasterTranslation(error.code)) {
            showToast({
                title: toasterTranslations(`${error.code}.negative.title`),
                description: toasterTranslations(`${error.code}.negative.description`),
                intent: 'error'
            })
            return
        }

        showToast(props)
    }
}
